<script>
	import AutoComplete from "simple-svelte-autocomplete";
	import { onMount } from "svelte";

	export let items = null;
	export let selectedItem = null;
	export let onCreate = null;
	export let onBlur = null;
	export let required = null;
	export let id = null;
	export let disabled = null;
	export let label = null;
	export let multiple = null;
	export let create = null;
	export let labelFieldName = null;
	export let valueFieldName = null;

	onMount(() => {
		if (required) {
			document.getElementById(id).required = true;
		}
	});
</script>

{#if label}
	<label for={id} class:isrequired={required}>{label}</label>
{/if}
<div>
	<AutoComplete
		{items}
		bind:selectedItem
		inputId={id}
		{create}
		createText={"We don't recognise that store. Press ENTER to add it anyway"}
		{onCreate}
		{onBlur}
		inputClassName="autoCompleteInput"
		{disabled}
		{required}
		{multiple}
		{labelFieldName}
		{valueFieldName}
	/>
</div>

<style>
	:global(.autoCompleteInput) {
		outline-width: 0;
		border: none;
	}

	:global(.input-container) {
		border: 1px solid #e4e6e8 !important;
		box-shadow: none !important;
		border-radius: 3px !important;
	}

	:global(.tags) {
		align-items: center;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
	}

	:global(.tag) {
		background-color: whitesmoke;
		align-items: center;
		border-radius: 4px 0 0 4px;
		color: #4a4a4a;
		display: inline-flex;
		font-size: 0.75rem;
		height: 2em;
		justify-content: center;
		line-height: 1.5;
		padding-left: 0.75em;
		padding-right: 0.75em;
		white-space: nowrap;
	}

	:global(.is-delete) {
		border-radius: 0 4px 4px 0;
		padding: 0;
		position: relative;
		width: 2em;
	}

	:global(.is-delete::before) {
		background-color: currentColor;
		content: "";
		display: block;
		left: 50%;
		position: absolute;
		top: 50%;
		transform: translateX(-50%) translateY(-50%) rotate(45deg);
		transform-origin: center center;
		height: 1px;
		width: 50%;
	}

	:global(.is-delete::after) {
		background-color: currentColor;
		content: "";
		display: block;
		left: 50%;
		position: absolute;
		top: 50%;
		transform: translateX(-50%) translateY(-50%) rotate(45deg);
		transform-origin: center center;
		height: 50%;
		width: 1px;
	}

	:global(.autocomplete) {
		height: auto !important;
		width: 100%;
	}

	:global(.autocomplete-list) {
		position: absolute !important;
		top: 100% !important;
	}
</style>
